<script>
import {
  pageInfosEtServicesPageContenuProps,
  usePageInfosEtServicesPageContenu
} from "./mixin";
import CmsContainer from "@/components/organisms/cms-container";
import Icon from "@/components/atoms/icon";
import LinkTo from "@/components/atoms/link-to";
import Divider from "@/components/atoms/divider/index";

export default {
  name: "PageContenu",
  scrollToTop: true,
  components: {
    CmsContainer,
    LinkTo,
    Icon,
    Divider
  },
  props: {
    ...pageInfosEtServicesPageContenuProps()
  },
  setup(props) {
    const { title, updated } = usePageInfosEtServicesPageContenu(props);

    onUpdated(updated);
    return { title };
  }
};
</script>

<template>
  <div
    class="u-bgcolor-white u-mb-md u-mt-sm u-p-md u-radius-md u-radius-none@sm"
    :class="context === 'cms' && 'u-container-cms u-ml-auto u-mr-auto u-ml-md@lg u-mr-md@lg'"
  >
    <template v-if="context == 'cms'">
      <div class="u-mt-sm u-ml-md u-flex u-flex-align-center u-color-grey-2 u-font-12">
        <LinkTo
          to="/infos-et-services"
          no-underline
          variant="grey-2"
          class="u-mr-xs"
        >
          infos et services
        </LinkTo>
        <Icon
          name="arrow-right"
          size="xxs"
          variant="grey-2"
        />
        <p class="u-ml-xs">
          <strong>{{ title }}</strong>
        </p>
      </div>
      <br>
      <Divider
        dotted
        class="u-mt-none u-mb-none"
      />
      <br>
    </template>
    <CmsContainer
      v-if="cmsReponse && cmsReponse.data && cmsReponse.data.attributes"
      :contents="cmsReponse.data.attributes.contents"
    />
  </div>
</template>
